import { useEffect, useState } from 'react';
import { FeatureFlag, useFeatureFlag } from '@/stores/auth';
import { useGetUserFlags } from '@/features/user-flags/hooks';
import { useSampleAccountsQuery } from '@/features/workspaces/hooks';

/**
 * Sample Workspace
 * interactive_demo_workspace / sample_workspace
 * Part of:
 * https://linear.app/customerio/project/sample-workspace-view-only-workspace-387ba35103c0/overview
 */

export const useSampleWorkspace = () => {
  const { data: flags, isLoading: flagsLoading } = useGetUserFlags();
  const { data: sampleAccount, isLoading: sampleAccountLoading } = useSampleAccountsQuery();
  const [hasViewed, setHasViewed] = useState<boolean | null>(null);
  const sampleAccountId = sampleAccount?.accountId ?? null;
  const sampleWorkspaceId = sampleAccount?.workspaceId ?? null;

  const isInteractiveDemoWorkspaceFeaureFlagEnabled = useFeatureFlag(FeatureFlag.InteractiveDemoWorkspace);
  const isSampleWorkspaceFeatureFlagEnabled = useFeatureFlag(FeatureFlag.SampleWorkspace);

  const isSampleWorkspaceEnabled = isInteractiveDemoWorkspaceFeaureFlagEnabled || isSampleWorkspaceFeatureFlagEnabled;

  useEffect(() => {
    // Only allow setting hasViewed if the user flag exists and the user has the feature flag enabled
    if (flags != null && isSampleWorkspaceEnabled) {
      setHasViewed(flags?.has_viewed_sample_workspace ?? false);
    }
  }, [flags, isSampleWorkspaceEnabled]);

  const isSampleWorkspace = (workspaceId: number | null | undefined) => {
    if (workspaceId == null) {
      return false;
    }

    return workspaceId === sampleWorkspaceId;
  };

  return {
    hasViewedSampleWorkspace: isSampleWorkspaceEnabled ? hasViewed : null,
    sampleAccountId,
    sampleWorkspaceId,
    isLoading: sampleAccountLoading || flagsLoading,
    isSampleWorkspace,
  };
};
